import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { node } from 'prop-types';

import Favicon from '@assets/images/logo.png';

const META_DESCRIPTION = `Trần Dũng ❤️ Khánh Ly Wedding`;

function MainLayout({ children }) {
  return (
    <Fragment>
      <Helmet>
        <title>Trần Dũng ❤️ Khánh Ly Wedding</title>
        <meta name="description" content={META_DESCRIPTION} />

        {/* Favicon */}
        <link rel="icon" type="image/png" href={Favicon} />

        {/* Preconnect to Google Fonts for better performance */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />

        {/* Fonts with display=swap for better performance */}
        <link
          href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Cookie&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Dancing+Script&display=swap"
          rel="stylesheet"
        />

        {/* SEO tags */}
        <meta property="og:title" content="The Wedding of Trần Dũng & Khánh Ly" />
        <meta property="og:site_name" content="The Wedding of Trần Dũng & Khánh Ly" />
        <meta property="og:description" content={META_DESCRIPTION} />
        <meta property="og:type" content="website" />
      </Helmet>
      <div id="page">{children}</div>
    </Fragment>
  );
}

MainLayout.propTypes = {
  children: node.isRequired,
};

export default MainLayout;
